/**
 * WebPage type
 * DOC: https://schema.org/WebPage
 */

import imageObject from './types/imageObject';
export const webPage = ({
  url,
  image,
  name,
  id,
  reviewedBy,
  isPartOf,
  inLanguage,
  speakable,
  hasPart,
  datePublished,
  publisher,
  dateModified,
  lastReviewed
}) => {
  if (!url || typeof url === 'undefined') {
    throw new Error('url argument is required');
  }
  if (!name || typeof name === 'undefined') {
    throw new Error('name argument is required');
  }
  const result = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': id,
    ...(publisher && {
      publisher
    }),
    ...(url && {
      url
    }),
    ...(name && {
      name
    }),
    ...(inLanguage && {
      inLanguage
    }),
    ...(isPartOf && {
      isPartOf
    }),
    ...(speakable && {
      speakable
    }),
    ...(image && {
      image: imageObject(image)
    }),
    ...(hasPart && {
      hasPart
    }),
    ...(datePublished && {
      datePublished
    }),
    ...(dateModified && {
      dateModified
    }),
    ...(reviewedBy && {
      reviewedBy
    }),
    ...(lastReviewed && {
      lastReviewed
    })
  };
  return JSON.stringify(result);
};